import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LocalizationService } from './localization.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./localization.service";
var TitleService = /** @class */ (function () {
    function TitleService(http, baseUrl, localizationService) {
        this.http = http;
        this.baseUrl = baseUrl;
        this.localizationService = localizationService;
        this.apiUrl = this.baseUrl + "api/titles";
    }
    TitleService.prototype.getTitles = function () {
        var _this = this;
        return new Observable(function (subscriber) {
            _this.getTitlesCall(subscriber);
            _this.localizationService.addLangSubscriber(subscriber, function (obs) { return _this.getTitlesCall(obs); });
        });
    };
    TitleService.prototype.getTitlesCall = function (subscriber) {
        var _this = this;
        var code = this.localizationService.getLocale();
        if (TitleService.cacheTitles[code]) {
            subscriber.next(TitleService.cacheTitles[code]);
            return;
        }
        this.http.get("" + this.apiUrl).subscribe(function (titles) {
            TitleService.cacheTitles[code] = titles.sort(_this.sortOtherLast);
            subscriber.next(TitleService.cacheTitles[code]);
        }, function (error) { return subscriber.error(error); });
    };
    // Make sure 'Other' is always at the end of the list no matter the language.
    TitleService.prototype.sortOtherLast = function (a, b) {
        if (a.type === 'Other')
            return 1;
        else if (b.type === 'Other')
            return -1;
        else
            return a.label < b.label ? -1 : 1;
    };
    TitleService.cacheTitles = {};
    TitleService.ngInjectableDef = i0.defineInjectable({ factory: function TitleService_Factory() { return new TitleService(i0.inject(i1.HttpClient), i0.inject("BASE_URL"), i0.inject(i2.LocalizationService)); }, token: TitleService, providedIn: "root" });
    return TitleService;
}());
export { TitleService };
